import component from './save.vue'

export default component
